import {
  BaseQueryApi,
  FetchArgs,
  fetchBaseQuery
} from '@reduxjs/toolkit/query/react';
import { Mutex } from 'async-mutex';

const baseUrl =
  (import.meta.env?.VITE_BASE_URL as string) || 'https://api.inexture.in';

const rawBaseQuery = fetchBaseQuery({
  baseUrl,
  prepareHeaders: (headers, { getState }) => {
    const auth = (getState() as any)?.app?.auth;
    if (auth?.isLoggedIn) {
      headers.set('Authorization', `Bearer ${auth?.token?.access}`);
    } else {
      headers.delete('Authorization');
    }
    return headers;
  }
});

const mutex = new Mutex();

export const baseQueryWithTokenRefresh = async (
  args: string | FetchArgs,
  api: BaseQueryApi,
  extraOptions: any
) => {
  const url = typeof args === 'string' ? args : args?.url;
  const skipAuth = url?.includes('/account/register');

  let result;
  if (skipAuth) {
    result = await fetchBaseQuery({ baseUrl })(args, api, extraOptions);
  } else {
    result = await rawBaseQuery(args, api, extraOptions);
  }

  if (result?.error?.status === 401) {
    if (!mutex.isLocked()) {
      const release = await mutex.acquire();
      try {
        const tokenState = (api.getState() as any)?.app?.auth;
        const refreshResult = await rawBaseQuery(
          {
            url: '/users/refresh/',
            method: 'POST',
            body: { refresh: tokenState?.token?.refresh },
            credentials: 'include'
          },
          api,
          extraOptions
        );

        if (refreshResult?.data) {
          api.dispatch({
            type: 'app/SET_AUTH_TOKEN',
            payload: refreshResult.data
          });
          result = await rawBaseQuery(args, api, extraOptions);
        } else {
          api.dispatch({ type: 'app/RESET_AUTH_TOKEN' });
          window.location.href = '/auth/login';
        }
      } catch (err) {
        console.error('Refresh token failed:', err);
        api.dispatch({ type: 'app/RESET_AUTH_TOKEN' });
        window.location.href = '/auth/login';
      } finally {
        release();
      }
    } else {
      await mutex.waitForUnlock();
      result = await rawBaseQuery(args, api, extraOptions);
    }
  }

  return result;
};
